import axios from "axios"
import { PoblacionReadingDtoProps } from "./DTOs/PoblacionReadingDto"
import { getPoblacionAdapter } from "./Poblacion.adapter"

export async function getPoblacionByCodigoPostal(
  codigoPostal: string
): Promise<PoblacionReadingDtoProps[]> {
  const { data } = await axios.get(`/Poblacion/by-codigopostal/${codigoPostal}`)

  return data.map((poblacion: PoblacionReadingDtoProps) =>
    getPoblacionAdapter(poblacion)
  )
}
